import React from 'react'
import CustomCalendar from '../calendar/customCalendar'
import ConstantsUtil from '../../context/constantsUtil'
import FormGroup from '../form-group'
import GeneralServices from '../../app/service/generalServices'
import * as popUp from '../../components/toastr'
import { InputNumber } from 'primereact/inputnumber'
import InputChooseFormaDePagamento from './provisoes/inputChooseFormaDePagamento'
import NFService from '../../app/service/estoque/NFService'
import HandleErrorService from '../../app/service/handleErrorService'
import NfseService from '../../app/service/nfse/NfseService'
import { classNames } from 'primereact/utils'
import DadosPagamentoSalvoParcelaProvisaoDialog from './provisoes/dadosPagamentoSalvoParcelaProvisaoDialog'
import InputValorAcrescimoDescontoParcelaProvisaoComponent from './inputValorAcrescimoDescontoParcelaProvisaoComponent'

class QuantidadeParcelasComponent extends React.Component {

    constructor(){
        super()
        this.nfService = new NFService()
        this.NFSeService = new NfseService()
    }

    state = {

        qtdParcelas: '',
        inputParcelasErrorClass: '',
        errorParcelasMessage: 'Informe a quantidade de Parcelas',

        pagamentoList: [],

        formaDePagamento: {},
        gravarEscolhaFormaDePagamento: false,

        parcelaToViewDadosPagamento: {},
        displayDadosPagamentoDialog: false,

        didUpdated: false,

    }

    componentDidMount(){
        this.setStates()
    }

    componentDidUpdate(){
        // console.log("didUpdate qtdParcelasComp")
        if( this.props.forceUpdate || !this.state.didUpdated ){
            // console.log("didUpdate de verdade qtdParcelasComp")
            this.setStates()

            this.setState({didUpdated: true})
            
            if(this.props.doneForcedUpdate){
                this.props.doneForcedUpdate()
            }

        }
    }

    setStates = () => {

        if(this.props.provisao){
            // console.log("setStates quantidadeParcelasComponent: ", this.props.provisao)
            if(this.props.provisao.formaDePagamento){
                this.preencheFormaDePagamentoSalvaFromProvisao()
            }
            else if(this.props.provisao.notaFiscal && !this.props.insideDre){
                this.preencheFormaDePagamentoSalvaFromNF(this.props.provisao.notaFiscal)
            }
        }
        else if(this.props.NF){
            // console.log("this.props.NF: ", this.props.NF)
            if(this.props.isNFSe){
                // console.log("NFSe")
                this.preencheFormaDePagamentoSalvaFromNFSe()
            }
            else{
                this.preencheFormaDePagamentoSalvaFromNF(this.props.NF)
            }
        }

        if(this.props.provisao || this.props.qtdParcelas || this.props.initialPagamentoList){
            this.preencheParcelas()
        }

    }

    setFormaDePagamento = (formaDePagamento, force = false) => {
        // console.log("setFormaDePagamento: ", this.state.formaDePagamento)
        if(force || !this.state.formaDePagamento || GeneralServices.isEmptyObject(this.state.formaDePagamento)){
            this.setState({formaDePagamento})
        }
    }

    preencheFormaDePagamentoSalvaFromProvisao = () => {
        if(this.props.provisao.formaDePagamento){
            this.setFormaDePagamento(this.props.provisao.formaDePagamento, true)
        }
    }

    preencheFormaDePagamentoSalvaFromNFSe = () => {
        

        if(this.props.NF?.formaDePagamentoFromCreateNFSe){
            this.setFormaDePagamento(this.props.NF.formaDePagamentoFromCreateNFSe, false)
        }

        if(GeneralServices.isEmptyObject(this.props.NF) || !this.props.NF || !this.props.NF.id){
            return;
        }

        // console.log("buscaFormaDePagamentoSalva nfse qtdParcelasComp")
        this.NFSeService.buscaFormaDePagamentoSalva(this.props.NF.id)
        .then(response => {
            if(response.data){
                this.setFormaDePagamento(response.data, true)
            }
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    preencheFormaDePagamentoSalvaFromNF = (NF) => {
        // console.log("buscaFormaDePagamentoSalva qtdParcelasComp: ", NF)
        this.nfService.buscaFormaDePagamentoSalva(NF.id)
        .then(response => {
            if(response.data){
                this.setFormaDePagamento(response.data, true)
            }
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    preencheParcelas = async () => {

        let quantidadeParcelas = 0;
        if(this.props.provisao){
            await this.setState({pagamentoList: this.props.provisao.parcelaProvisaoList})
            quantidadeParcelas = this.props.provisao.quantidadeParcelas
        } else if(this.props.initialPagamentoList){
            await this.setState({pagamentoList: this.props.initialPagamentoList})
        }

        const event= {
            target:{
                value: this.props.qtdParcelas ? this.props.qtdParcelas : quantidadeParcelas
            },
            provisaoSalva: true
        }
        this.handleQuantidadeParcelasChange(event)

    }

    reset = () => {
        this.handleQuantidadeParcelasChange({target: {value: ''}})
        this.setFormaDePagamento({}, true)
    }

    handleQuantidadeParcelasChange = async (event) => {
        // console.log("handleQuantidadeParcelasChange: ", event)
        let currentValue = this.state.qtdParcelas
        let valorInicialParecla = null

        let value = event.target.value
        if(value && value < 0){
            value*=-1
        }

        const qtdParcelas = value;

        // if( (!currentValue || currentValue === 0) && this.props.valorTotalProvisao) {
            let valorTotal = this.calculaValorFinalASerPago()
            // console.log("valorTotal: ", valorTotal)
            // console.log("qtdParcelas: ", qtdParcelas)
            valorInicialParecla = GeneralServices.formatTo2CasasDecimais(valorTotal/qtdParcelas)
        // }
        
        await this.setState({ qtdParcelas })

        var pagamentoList = this.state.pagamentoList
        // console.log("pagamentoList: ", JSON.parse(JSON.stringify(pagamentoList)))
        
        if(qtdParcelas && qtdParcelas !== 0){

            var initialIndex = 0
            var shouldExecuteLoop = true

            if(pagamentoList && pagamentoList.length > 0){
                if(qtdParcelas > pagamentoList.length){
                    initialIndex = pagamentoList.length
                }
                else{
                    pagamentoList = pagamentoList.slice(0, qtdParcelas)
                    // console.log("pagamentoList pós slice: ", JSON.parse(JSON.stringify(pagamentoList)))
                    shouldExecuteLoop = false
                }

            }
            else{
                pagamentoList = []
            }

            if(shouldExecuteLoop){
                for(var i = initialIndex; i < this.state.qtdParcelas; i++){
                    pagamentoList.push(
                        {
                            parcela: i+1,
                            data: '',
                            dataView: '',
                            valor: valorInicialParecla,
                            inputDateErrorClass: '',
                            inputValorErrorClass: '',
                        }
                    )
                }
                for(var i = 0; i < initialIndex; i++){
                    let pagamentoItem = pagamentoList[i]
                    pagamentoItem.valor = valorInicialParecla
                }

            }
            else if(initialIndex === 0){
                // console.log("initialIndex: ", initialIndex)
                // console.log("event: ", event)
                if(!event.provisaoSalva){
                    // console.log("entrou no loop de sem provisaoSalva")
                    for(let item of pagamentoList){
                        // let pagamentoItem = pagamentoList[0]
                        // pagamentoItem.valor = valorInicialParecla
                        item.valor = valorInicialParecla
                    }
                }
            }

        }
        else{
            pagamentoList = []
        }
        
        // console.log("pagamentoList final: ", JSON.parse(JSON.stringify(pagamentoList)))
        await this.setState({pagamentoList})
        // console.log('this.state.pagamentoList', this.state.pagamentoList)
        this.preencheDatasDePagamentoParcelaComDiaVencimentoCartao()

    }

    preencheDatasDePagamentoParcelaComDiaVencimentoCartao = () => {
        
        let formaDePagamento = this.state.formaDePagamento
        
        if(formaDePagamento.tipo !== ConstantsUtil.tipoFormaDePagamentoCartaoDeCredito){
            return
        }

        if(!formaDePagamento || GeneralServices.isEmptyObject(formaDePagamento) || !this.state.qtdParcelas){
            return;
        }

        let proximosDiasDoMesList = GeneralServices.proximosDiasDoMes(formaDePagamento.diaVencimento, this.state.qtdParcelas)
        let pagamentoList = this.state.pagamentoList
        if(pagamentoList && pagamentoList.length > 0) {
            
            for(let i = 0; i < pagamentoList.length; i++){
                let pagamentoItem = pagamentoList[i]
                if(pagamentoItem.data || pagamentoItem.dataView){
                    continue
                }
                pagamentoItem.dataView = proximosDiasDoMesList[i]
                pagamentoItem.data = GeneralServices.convertJSDateToBrDate(pagamentoItem.dataView)
            }

            // console.log("pagamentoList alterado: ", pagamentoList)
            this.setState({pagamentoList})

        }
    }

    handleFormaDePagamentoChange = async formaDePagamento => {
        // console.log("handleFormaDePagamentoChange: ", formaDePagamento)
        // console.log("this.state.pagamentoList: ", this.state.pagamentoList)
        await this.setState({formaDePagamento})
        this.preencheDatasDePagamentoParcelaComDiaVencimentoCartao()

    }

    handleLimparFormaDePagamento = () => {
        this.setFormaDePagamento({}, true)
    }

    handleGravarEscolhaFormaDePagamentoChange = (checked) => {
        this.setState({gravarEscolhaFormaDePagamento: checked})
    }

    getDescricaoFormaDePagamento = () => {
        let descricao = this.state.formaDePagamento && this.state.formaDePagamento.descricao ? this.state.formaDePagamento.descricao : ''
        return descricao
    }

    handleDateLoopChange = async (event, index) => {

        var value = event.target.value
        const valueFormatted = GeneralServices.convertJSDateToBrDate(value)
        
        var pagamentoList = this.state.pagamentoList
        // console.log("pagamentoList: ", pagamentoList)

        var obj = pagamentoList[index]
        obj.data = valueFormatted
        obj.dataView = value

        pagamentoList[index] = obj

        await this.setState({pagamentoList})

        // console.log("this.state.pagamentoList", this.state.pagamentoList)
    }    

    handleValorParcelaLoopChange = async (event, index) => {

        // console.log("handleValorParcelaLoopChange: ", event.target)
        const name = event.target.name
        const value = event.target.value
        // value = GeneralServices.convertJSDateToBrDate(value)
        
        var pagamentoList = this.state.pagamentoList

        var obj = pagamentoList[index]
        obj[name] = value

        pagamentoList[index] = obj

        await this.setState({pagamentoList})

        // console.log("this.state.pagamentoList", this.state.pagamentoList)
    }

    resetView = () => {
        this.setState({inputParcelasErrorClass: ''})

        this.state.pagamentoList.forEach(pagamentoItem => {
            pagamentoItem.inputDateErrorClass = ''
            pagamentoItem.inputValorErrorClass = ''
        })
    }

    calculaValorFinalParcelaComAcrescimoDesconto = (parcela) => {
        let valorInicial = parcela.valor
        let valorAcrescimo = parcela.valorTotalAcrescimo ? parcela.valorTotalAcrescimo : 0.0
        let valorDesconto = parcela.valorTotalDesconto ? parcela.valorTotalDesconto : 0.0
        let valorFinalComAcrescimoDesconto = valorInicial + valorAcrescimo - valorDesconto
        return valorFinalComAcrescimoDesconto
    }

    checkData = () => {

        this.resetView()

        if(!this.existeValorASerPago()){
            return {checkGeral: true, apenasCheckSomatorioFalhou: false}
        }
        
        let check = true
        let checkSomatorio = true

        if(!this.state.qtdParcelas || this.state.qtdParcelas <= 0){
            this.setState({inputParcelasErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }
        else {
            var valorTotalProvisaoDigitado = parseFloat(0)
            this.state.pagamentoList.forEach(pagamentoItem => {
                if(!pagamentoItem.data){
                    pagamentoItem.inputDateErrorClass = ConstantsUtil.primereactInputErrorClass
                    check = false
                }
                if(!pagamentoItem.valor){
                    valorTotalProvisaoDigitado = undefined
                    pagamentoItem.inputValorErrorClass = ConstantsUtil.primereactInputErrorClass
                    check = false
                }

                if(valorTotalProvisaoDigitado !== undefined){
                    // console.log("pagamentoItem: ", pagamentoItem)
                    // valorTotalProvisaoDigitado += parseFloat(pagamentoItem.valorFinalComAcrescimoDesconto)
                    valorTotalProvisaoDigitado += parseFloat(this.calculaValorFinalParcelaComAcrescimoDesconto(pagamentoItem))
                }

            })
            // console.log("valorTotalProvisaoDigitado: ", valorTotalProvisaoDigitado)
            if(valorTotalProvisaoDigitado !== undefined){
                // console.log("valorTotalProvisaoDigitado: ", GeneralServices.formatTo2CasasDecimais(valorTotalProvisaoDigitado))
                // console.log("this.props.valorTotalProvisao: ", GeneralServices.formatTo2CasasDecimais(this.props.valorTotalProvisao))
                // console.log("somatorio das parcelas digitadas pelo usuario: ", valorTotalProvisaoDigitado)
                // console.log("valor a ser pago: ", this.calculaValorFinalASerPago())
                let valorTotalProvisaoDigitadoFormatado = GeneralServices.formatTo2CasasDecimais(valorTotalProvisaoDigitado)
                let valorFinalASerPago = this.calculaValorFinalASerPago()
                if( 
                    valorTotalProvisaoDigitadoFormatado
                    !== valorFinalASerPago
                ){
                    popUp.warningPopUp(`Somatório do valor das parcelas diferente do Valor Total.<br/>
                        Valor das parcelas: ${valorTotalProvisaoDigitadoFormatado}<br/>
                        Valor total da provisão: ${valorFinalASerPago}
                    `)
                    checkSomatorio = false
                }
            }

        }

        let checkGeral = check && checkSomatorio
        
        return {checkGeral, apenasCheckSomatorioFalhou: check && !checkSomatorio}

    }

    getResultObject = () => {
        const obj = {
            quantidadeParcelas: this.state.qtdParcelas ? this.state.qtdParcelas : 0,
            valorTotal: this.calculaValorFinalASerPago(),
            parcelaProvisaoList: this.state.pagamentoList,
            formaDePagamento: this.state.formaDePagamento,
            gravarEscolhaFormaDePagamento: this.state.gravarEscolhaFormaDePagamento
        }

        // console.log("obj: ", obj)
        
        return obj
    }

    calculaValorFinalASerPago = () => {

        if(this.props.NF && this.props.NF.tipo === ConstantsUtil.tipoNFDevolucaoEntradaLabel){
            return parseFloat(0.0)
        }

        let valorTotalProvisao = this.props.valorTotalProvisao ? this.props.valorTotalProvisao : 0.0
        let valorAcrescimoDesconto = this.props.valorAcrescimoDesconto ? this.props.valorAcrescimoDesconto : 0.0
        let valorDescontoBonificacao = this.props.valorDescontoBonificacao ? this.props.valorDescontoBonificacao : 0.0
        let valorDescontoDevolucao = this.props.valorDescontoDevolucao ? this.props.valorDescontoDevolucao : 0.0
        let valorFinalASerPago = GeneralServices.formatTo2CasasDecimais(
            valorTotalProvisao + valorAcrescimoDesconto - valorDescontoBonificacao - valorDescontoDevolucao
        )
        // console.log("valorFinalASerPago: ", valorFinalASerPago)
        return parseFloat(valorFinalASerPago)
    }

    existeValorASerPago = () => {
        let valorASerPago = parseFloat(this.calculaValorFinalASerPago())
        let existeValorASerPago = (valorASerPago !== 0.00)
        return existeValorASerPago;
    }

    viewDadosPagamento = (parcelaProvisao) => {
        this.setState({
            parcelaToViewDadosPagamento: parcelaProvisao,
            displayDadosPagamentoDialog: true
        })
    }

    hideDadosPagamentoDialog = () => {
        this.setState({
            parcelaToViewDadosPagamento: {},
            displayDadosPagamentoDialog: false
        })
    }

    hideAcrescimoDescontoDialog = () => {
        if(this.props.research){
            this.props.research()
        }
    }

    getDisabled = () => {
        //Dá problema quando busca no Dre Unificado
        // console.log("this.props.insideDre: ", this.props.insideDre)
        // console.log("this.props.unificar: ", this.props.unificar)
        return this.props.insideDre && this.props.unificar
    }

    render(){

        const renderDadosPagamentoDialog = () => {
            return (
                <DadosPagamentoSalvoParcelaProvisaoDialog
                    visible={this.state.displayDadosPagamentoDialog}
                    hideDialog={this.hideDadosPagamentoDialog}
                    idParcelaToViewDadosPagamento={this.state.parcelaToViewDadosPagamento.id}
                />
            )
        }

        const renderStatus = (parcelaProvisao) => {

            if(!this.props.isVisualizacaoProvisao || !parcelaProvisao)
                return (<></>)

            const classes = classNames({
                'superavitValue': parcelaProvisao.status === ConstantsUtil.parcelaProvisaoPagaLabel,
                'deficitValue': parcelaProvisao.status === ConstantsUtil.parcelaProvisaoAguardandoPagamentoLabel,
                'linkValue': parcelaProvisao.status === ConstantsUtil.parcelaProvisaoPagaLabel
            });

            if(parcelaProvisao.status === ConstantsUtil.parcelaProvisaoPagaLabel){
                return(
                    <a 
                        className={classes}
                        onClick={() => this.viewDadosPagamento(parcelaProvisao)}
                    >
                        {parcelaProvisao.status}
                    </a>
                )
            }
            else{
                return(
                    <div className={classes}>
                        {/* {GeneralServices.renderBodyColumnInOneLine(parcelaProvisao.status, rowIndex)} */}
                        {parcelaProvisao.status}
                    </div>
                )
            }
        }

        const renderParcelasList = () => {
            var componentParcelaList = []
            if(this.state.qtdParcelas && this.state.qtdParcelas !== 0){
                for(var i = 0; i < this.state.qtdParcelas; i++){
                    componentParcelaList.push(renderParcela(i))
                }

                componentParcelaList.push(<br/>)

                return componentParcelaList

            }
        }

        const renderValorAcrescimoDescontoParcela = (colMdValorParcela, index, item) => {
            if(this.props.insideEditDialog && !this.props.hideAcrescimoDesconto)
            return (
                <>
                    <div className = {`col-md-${colMdValorParcela}`}>
                        <InputValorAcrescimoDescontoParcelaProvisaoComponent
                            label={`Valor de Desconto ${index+1}`}
                            idParcelaProvisao={item ? item.id : null}
                            index={index}
                            valor={item ? item.valorTotalDesconto : null}
                            isDesconto
                            hideDialog={this.hideAcrescimoDescontoDialog}
                            reRenderEditDialog={this.props.reRenderEditDialog}
                            disabled={this.getDisabled()}
                        />
                    </div>

                    <div className = {`col-md-${colMdValorParcela}`}>
                        <InputValorAcrescimoDescontoParcelaProvisaoComponent
                            label={`Valor de Acréscimo ${index+1}`}
                            idParcelaProvisao={item ? item.id : null}
                            index={index}
                            valor={item ? item.valorTotalAcrescimo : null}
                            isAcrescimo
                            hideDialog={this.hideAcrescimoDescontoDialog}
                            reRenderEditDialog={this.props.reRenderEditDialog}
                            disabled={this.getDisabled()}
                        />
                    </div>

                    <div className = {`col-md-${colMdValorParcela}`}>
                        <label>Valor Final</label>
                        <InputNumber 
                            style={{backgroundColor: 'gray'}}
                            mode="decimal" locale="pt-BR" minFractionDigits={2}
                            disabled
                            value={item ? this.calculaValorFinalParcelaComAcrescimoDesconto(item) : null}
                        />
                    </div>

                </>
            )
        }

        const renderParcelaComponent = (item, index, dateView, inputDateErrorClass, valor, inputValorErrorClass) => {
            let colMdDataParcela = 2
            let colMdValorParcela = 2
            if(this.props.insideDialog){
                colMdDataParcela = 6
                colMdValorParcela= 6
            }
            return (
                <>
                    <div className='row'>

                        <div className = {`col-md-${colMdDataParcela}`}>
                            <CustomCalendar
                                label={`Data da Parcela ${index+1}`}
                                value={ dateView }
                                showMultipleMonths
                                noHTMLFormat
                                onChange={(event) => this.handleDateLoopChange(event, index)}
                                inputDateErrorClass={inputDateErrorClass}
                                errorDateMessage={inputDateErrorClass ? ConstantsUtil.informeDataErrorMenssage : ''}
                                disabled={this.props.disabled || GeneralServices.isTelaPreValidacaoNFs()}
                            />
                        </div>

                        <div className = {`col-md-${colMdValorParcela}`}>
                            <label htmlFor="valor" style={{display: 'block'}}>{`Valor da Parcela ${index+1}`}</label>
                                <InputNumber
                                    className={inputValorErrorClass}
                                    name="valor"
                                    value={valor}
                                    onValueChange={(event) => this.handleValorParcelaLoopChange(event, index)}
                                    // onKeyDown={this.handleKeyPress}
                                    mode="decimal" locale="pt-BR" minFractionDigits={2}
                                    disabled={this.props.disabled || GeneralServices.isTelaPreValidacaoNFs()}
                                />                      
                            <div className="row">
                                <div className="col-md-12">
                                <small id="valorError" className="p-error">{inputValorErrorClass ? ConstantsUtil.informeValorErrorMenssage: ""}</small>
                                </div>
                            </div>          
                        </div>

                        {renderValorAcrescimoDescontoParcela(colMdValorParcela, index, item)}

                        <div style={{marginTop: '30px'}}>
                            {renderStatus(item)}
                        </div>

                    </div>
                </>
            )
        }

        const renderFinalParcelaComponent = (item, index, dateView, inputDateErrorClass, valor, inputValorErrorClass) => {
            if(this.props.insideDialog){
                return (
                    <div className='col-md-12'>
                        {renderParcelaComponent(item, index, dateView, inputDateErrorClass, valor, inputValorErrorClass)}
                    </div>
                )
            }
            else{
                return renderParcelaComponent(item, index, dateView, inputDateErrorClass, valor, inputValorErrorClass)
            }
        }
        
        const renderParcela = (index) => {

            const item = this.state.pagamentoList[index]

            const dateView = item ? item.dataView : ''
            // console.log(`dateView ${index}:`, dateView)
            const inputDateErrorClass = item ? item.inputDateErrorClass : ''
            
            const valor = item ? item.valor : ''
            const inputValorErrorClass = item ? item.inputValorErrorClass : ''

            return (
                <>
                    {renderFinalParcelaComponent(item, index, dateView, inputDateErrorClass, valor, inputValorErrorClass)}
                </>
            )
        }

        const renderFormaDePagamento = () => {
            if(!this.props.hideFormaDePagamento){
             return (
                 <div className={`col-md-9`}>
                     <InputChooseFormaDePagamento
                         selectedFormaDePagamentoLabel={this.getDescricaoFormaDePagamento()}
                         handleSelectionChange={this.handleFormaDePagamentoChange}
                         handleLimparFormaDePagamento={this.handleLimparFormaDePagamento}
                         gravarEscolhaFormaDePagamento={this.state.gravarEscolhaFormaDePagamento}
                         handleGravarEscolhaChange={this.handleGravarEscolhaFormaDePagamentoChange}
                         reRenderEditDialog={this.props.reRenderEditDialog}
                         disabled={this.getDisabled()}
                     />
                 </div>
             )
            }
        }

        const renderQdtParcelas = () => {
            // let colMd = 3
            // if(this.props.insideDialog){
            //     colMd = 5
            // }
            return (
                <>
                <div className='row'>
                <div className = {`col-md-3`}>
                    <FormGroup label = "Quantidade de Parcelas" htmlFor = "InputParcelas">
                        <input
                            type="number"
                            id="inputQtdParcelas"
                            className={"form-control " + this.state.inputParcelasErrorClass}
                            name="qtdParcelas"
                            value = {this.state.qtdParcelas}
                            onChange={this.handleQuantidadeParcelasChange}
                            // onKeyPress={this.handleKeypress}
                            placeholder="Digite a quantidade de Parcelas"
                            disabled={this.props.disabled || GeneralServices.isTelaPreValidacaoNFs()}
                        />
                        <div className="invalid-feedback">{this.state.errorParcelasMessage}</div>
                    </FormGroup>
                </div>
                    {renderFormaDePagamento()}
                </div>
                </>
            )
        }

        const renderFinalQdtParcelas = () => {

            if(this.props.insideDialog) {
                return (
                    <div className='col-md-12'
                        style={{marginTop: '20px'}}
                    >
                        {renderQdtParcelas()}
                    </div>                    
                )
            }

            else{
                return renderQdtParcelas()
            }
        }

        const renderComponent = () => {
            if(this.existeValorASerPago())
            return (
                <>

                    {renderFinalQdtParcelas()}

                    {renderParcelasList()}
    
                </>
            )
        }

        return (
            <>
                {renderComponent()}
                {renderDadosPagamentoDialog()}
            </>
        )
    }


}
export default QuantidadeParcelasComponent
